let currentSlideGrid = 0;
let prev = document.querySelector(".prev-slide");
let next = document.querySelector(".next-slide");


function showSlide(index) {
  const slides = document.querySelector(".announcment-bar__slider");

  if (!slides) {
    
    return;
  }

  currentSlideGrid =
    (index + slides.childElementCount) % slides.childElementCount;
  const translateValue = -currentSlideGrid * 100 + "%";
  slides.style.transform = "translateX(" + translateValue + ")";
}

function changeSlide(event, direction) {
  event.preventDefault();
  showSlide(currentSlideGrid + direction);
}

function changeSlideAuto(direction) {
  showSlide(currentSlideGrid + direction);
}

document.addEventListener("DOMContentLoaded", () => {
  showSlide(0);
});


setInterval(function() {
  changeSlideAuto(1);
}, 10000);

// video part

const videoFullWrapper = document.getElementById('video-with-previw-mode_full-desktop');
const videoFullDektop = document.getElementById('video-with-previev-wrapper__desktop-full');
const videoFullMobile = document.getElementById('video-with-previev-wrapper__mobile-full');

function showVideo() {
  document.querySelector('.video-with-previw-mode_preview').style.display = 'none';
  videoFullWrapper.style.display = 'block';
  videoFullDektop.play();
}

function showVideo2() {
  document.querySelector('.video-with-previw-mode_preview').style.display = 'none';
  videoFullWrapper.style.display = 'block';
  videoFullMobile.play()
}

document.addEventListener("DOMContentLoaded", function() {
  function checkAutoPlay() {
    var mobileVideo = document.getElementById("video-with-previev-wrapper__mobile-preview");
    var desktopVideo = document.getElementById("video-with-previev-wrapper__desktop-preview");

    if (mobileVideo || desktopVideo) {
         if (window.matchMedia("(max-width: 767px)").matches) {
      mobileVideo.muted = true;
      mobileVideo.setAttribute('autoplay', "true");
      mobileVideo.play().catch(function(error) {
        console.error("Error playing mobile video:", error);
      });
    } else {
      desktopVideo.muted = true; // Добавляем эту строку для обхода политик автовоспроизведения
      desktopVideo.play().catch(function(error) {
        console.error("Error playing desktop video:", error);
      });
    } 
    }
  }

  checkAutoPlay();

  function checkAutoPlayMobile() {
    var mobileVideo = document.getElementById("video-with-previev-wrapper__mobile-preview");

    if (window.matchMedia("(max-width: 767px)").matches && navigator.userAgent.match(/(iPhone|iPod|iPad)/i) && mobileVideo) {
      mobileVideo.setAttribute('autoplay', "true");
    }
  }

  checkAutoPlayMobile()
});



document.addEventListener("DOMContentLoaded", function() {
  let annBarWrapper = document.querySelector('.announcment-bar__slider-top-wrapper');
  let slides = document.querySelectorAll('.announcement-bar__all-width-text-wrapper > p');
  let currentSlide = 0;

  function showSlide(index) {
    if (slides.length > 2) {
         slides.forEach(function(slide) {
      slide.classList.remove('slide-ann-bar-active');
      slide.style.transition = "opacity 1.5s ease"
    });
    slides[index].classList.add('slide-ann-bar-active'); 
    }
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }


  showSlide(currentSlide);


  setInterval(nextSlide, 4000);
});
